import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { FilePlus2, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LI, STATUS_TONE, fmtPlain, dmy } from "@/lib/lumpsum";

// Lump-sum invoices drafted for this claim — separate records; nothing here alters the claim's costs, settlement or stage
export default function ClaimInvoicesTab({ claim }) {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { axios.get(LI, { params: { claim_id: claim.id } }).then(({ data }) => setRows(data)).catch(() => setRows([])); }, [claim.id]);
  return (
    <section className="rounded-2xl border border-white/[0.06] bg-[#121826] p-4 space-y-3" data-testid="tab-panel-invoices">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-[11px] uppercase tracking-[0.14em] font-bold text-slate-300">Lump-sum invoices</h2>
          <p className="text-xs text-slate-500 mt-0.5">One consolidated amount for the insurer / third party, in your standard letterhead. Drafting or finalising never changes this claim's figures or stage.</p>
        </div>
        <Button onClick={() => navigate(`/claims/${claim.id}/lumpsum/new`)} data-testid="draft-lumpsum-btn" className="h-9 bg-rose-500 hover:bg-rose-400 text-slate-950 font-bold"><FilePlus2 className="w-4 h-4 mr-1.5" /> Draft Lump-Sum Invoice</Button>
      </div>
      {rows === null ? <p className="text-xs text-slate-500">Loading…</p> : rows.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-700 p-6 text-center text-sm text-slate-500" data-testid="lumpsum-empty"><FileText className="w-6 h-6 mx-auto mb-1 text-slate-600" />No lump-sum invoice drafted for this claim yet.</div>
      ) : (
        <ul className="divide-y divide-white/[0.05]" data-testid="lumpsum-list">
          {rows.map((r) => (
            <li key={r.id} className="py-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
              <Link to={`/claims/${claim.id}/lumpsum/${r.id}`} className="font-mono-num font-bold text-rose-300 hover:underline" data-testid={`lumpsum-open-${r.id}`}>{r.invoice_no}</Link>
              <span className={`text-[10px] font-bold uppercase tracking-wider rounded-full border px-2 py-0.5 ${STATUS_TONE[r.status]}`}>{r.status}</span>
              <span className="text-slate-400">{dmy(r.invoice_date)}</span>
              <span className="text-slate-300 truncate max-w-[220px]">{r.bill_to_name || "—"}</span>
              <span className="text-slate-500 text-xs truncate max-w-[200px]">{r.description}</span>
              <span className="ml-auto font-mono-num font-bold">S${fmtPlain(r.total)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
